// extracted by mini-css-extract-plugin
export default {"dot-flashing":"ThreeDotsAnimation_dot-flashing__xxtQZ","dotFlashing":"ThreeDotsAnimation_dotFlashing__HOfoX"};